// ── icons (inline stroke SVG, never emoji) ────────────────────────────────
function I({ d, size = 20 }: { d: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  )
}
export const Icons = {
  back: (s?: number) => <I size={s} d="m15 6-6 6 6 6" />,
  chevron: (s?: number) => <I size={s} d="m9 6 6 6-6 6" />,
  /** opens in its own window or tab, in place of the chevron */
  external: (s?: number) => (
    <I size={s} d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
  ),
  up: (s?: number) => <I size={s} d="m6 15 6-6 6 6" />,
  /** double chevrons: open, or close, everything under (the chain's Expand all and Collapse all) */
  expandAll: (s?: number) => <I size={s} d="m7 6 5 5 5-5M7 13l5 5 5-5" />,
  collapseAll: (s?: number) => <I size={s} d="m7 11 5-5 5 5M7 18l5-5 5 5" />,
  refresh: (s?: number) => <I size={s} d="M20 12a8 8 0 1 1-2.34-5.66M20 4v5h-5" />,
  bug: (s?: number) => (
    <I
      size={s}
      d="M9 7a3 3 0 0 1 6 0M8 9h8v6a4 4 0 0 1-8 0zM12 9v10M4 12h4M16 12h4M5 7l3 2M19 7l-3 2M5 18l3-2M19 18l-3-2"
    />
  ),
  sliders: (s?: number) => <I size={s} d="M4 7h9M17 7h3M15 5v4M4 17h3M11 17h9M9 15v4" />,
  people: (s?: number) => (
    <I
      size={s}
      d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21v-1a7 7 0 0 1 14 0v1M16 3.5a4 4 0 0 1 0 7.5M22 21v-1a7 7 0 0 0-4-6.3"
    />
  ),
  close: (s?: number) => <I size={s} d="M6 6l12 12M18 6 6 18" />,
  menu: (s?: number) => <I size={s} d="M4 6h16M4 12h16M4 18h16" />,
  invite: (s?: number) => (
    <I size={s} d="M15 20c0-3-2.7-5.5-6-5.5S3 17 3 20M9 11.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8M19 8v6M16 11h6" />
  ),
  /** The "..." that opens a person or conversation menu, the same everywhere. */
  more: (s?: number) => (
    <svg viewBox="0 0 24 24" width={s ?? 20} height={s ?? 20} aria-hidden="true" fill="currentColor">
      <circle cx="5" cy="12" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="19" cy="12" r="2" />
    </svg>
  ),
  /** Favorite: outlined, or filled when on (the color comes from the button). */
  star: (on?: boolean, s?: number) => (
    <svg
      viewBox="0 0 24 24"
      width={s ?? 22}
      height={s ?? 22}
      aria-hidden="true"
      fill={on ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinejoin="round"
    >
      <path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z" />
    </svg>
  ),
  map: (s?: number) => (
    <I
      size={s ?? 22}
      d="M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
    />
  ),
  /** a farm gate: two posts, two rails, braced across (bugs.md: the old one read as a house) */
  gate: (s?: number) => <I size={s ?? 22} d="M4 21V5M20 21V5M4 8h16M4 18h16M12 8v10M4 8l8 10M20 8l-8 10" />,
  wall: (s?: number) => <I size={s ?? 22} d="M3 5h18v14H3zM3 10h18M3 15h18M9 5v5M15 10v5M9 15v4" />,
  inbox: (s?: number) => <I size={s ?? 22} d="M4 5h16v11H8l-4 4V5z" />,
  bell: (s?: number) => <I size={s ?? 22} d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4l2-2z M10 20a2 2 0 0 0 4 0" />,
  chat: (s?: number) => <I size={s ?? 22} d="M4 5h16v11H9l-5 4V5zM8.5 10.5h.01M12 10.5h.01M15.5 10.5h.01" />,
  you: (s?: number) => <I size={s ?? 22} d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21c1-5 5-7 8-7s7 2 8 7" />,
  search: (s?: number) => <I size={s ?? 18} d="M18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm2 9-3.5-3.5" />,
  bolt: (s?: number) => <I size={s ?? 18} d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />,
  check: (s?: number) => <I size={s ?? 18} d="m5 12 5 5 9-10" />,
  /** a key: the console's token for the moderation tools (apps/mod) */
  key: (s?: number) => (
    <I
      size={s ?? 18}
      d="M21 2l-9.6 9.6M15.5 7.5l3 3L22 7l-3-3M2 15.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0"
    />
  ),
  /** a tap (or a knock): a finger pressing */
  tap: (s?: number) => (
    <I
      size={s ?? 18}
      d="M9 12V5.5a1.5 1.5 0 0 1 3 0V11M12 10.5a1.5 1.5 0 0 1 3 0V12M15 11.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-.5a6 6 0 0 1-5-2.7L4 14.5a1.5 1.5 0 0 1 2.4-1.8L9 15"
    />
  ),
  /** a time: a clock face */
  clock: (s?: number) => <I size={s ?? 18} d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2" />,
  /** dates: when someone joined and was last seen (console › Users, narrow) */
  calendar: (s?: number) => <I size={s ?? 18} d="M4 6h16v15H4zM4 10h16M8 3v4M16 3v4" />,
  /** verified (a spot, say): a tick in a circle */
  verified: (s?: number) => <I size={s ?? 18} d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12l3 3 5-6" />,
  alert: (s?: number) => <I size={s ?? 18} d="M12 3 2 21h20L12 3zM12 10v5M12 18h.01" />,
  info: (s?: number) => <I size={s ?? 16} d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5M12 8h.01" />,
  share: (s?: number) => <I size={s ?? 16} d="M12 3v12M8 7l4-4 4 4M5 12v8h14v-8" />,
  mail: (s?: number) => <I size={s ?? 18} d="M3 5h18v14H3zM3 6l9 7 9-7" />,
  /** call: a handset (the phone's dialer, tel:) */
  /** a contact card: add to the phone's own Contacts */
  contact: (s?: number) => (
    <I
      size={s}
      d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM5.5 16c.6-1.6 2-2.4 3.5-2.4s2.9.8 3.5 2.4M15 10h3M15 14h3"
    />
  ),
  phone: (s?: number) => (
    <I
      size={s ?? 18}
      d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"
    />
  ),
  /** a text message (the phone's own, sms:); `chat` is a message in the app */
  sms: (s?: number) => (
    <I size={s ?? 18} d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12zM8 11h8M8 14h5" />
  ),
  /** a website: a globe */
  globe: (s?: number) => (
    <I
      size={s ?? 18}
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9z"
    />
  ),
  lock: (s?: number) => <I size={s ?? 18} d="M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4" />,
  shield: (s?: number) => <I size={s ?? 20} d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3z" />,
  plus: (s?: number) => <I size={s ?? 22} d="M12 5v14M5 12h14" />,
  /** react to a message (FR-CHT-16): a face */
  react: (s?: number) => (
    <I size={s ?? 18} d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8.5 14a4 4 0 0 0 7 0M9 9.5h.01M15 9.5h.01" />
  ),
  /** reply to a Wall post (FR-WAL-16): an arrow back */
  reply: (s?: number) => <I size={s ?? 18} d="M10 8 5 13l5 5M5 13h9a5 5 0 0 0 5-5V6" />,
  send: (s?: number) => <I size={s ?? 18} d="M4 12 20 4l-6 16-3-7-7-1z" />,
  edit: (s?: number) => <I size={s ?? 18} d="M4 20h4L19 9l-4-4L4 16v4zM14 6l4 4" />,
  copy: (s?: number) => <I size={s ?? 18} d="M9 9h11v11H9zM5 15H4V4h11v1" />,
  /** a bin: delete on your side (Clear called-off events) */
  trash: (s?: number) => <I size={s ?? 18} d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />,
  download: (s?: number) => <I size={s ?? 18} d="M12 4v11M7 10l5 5 5-5M5 20h14" />,
  qr: (s?: number) => (
    <I size={s ?? 18} d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2M14 18v2M18 18h2v2h-2z" />
  ),
  megaphone: (s?: number) => <I size={s ?? 22} d="M3 10v4h3l8 5V5L6 10H3zM18 9a4 4 0 0 1 0 6" />,
  /** take an announcement down (console): the megaphone, struck through */
  megaphoneOff: (s?: number) => <I size={s ?? 22} d="M3 10v4h3l8 5V5L6 10H3zM18 9a4 4 0 0 1 0 6M3 3l18 18" />,
  camera: (s?: number) => (
    <I size={s ?? 22} d="M4 8h3l2-3h6l2 3h3v11H4zM12 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
  ),
  pin: (s?: number) => (
    <I
      size={s ?? 20}
      d="M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
    />
  ),
  /** a pushpin, for pinning to the top (a conversation); `pin` is the map's */
  pushpin: (s?: number) => (
    <I
      size={s ?? 20}
      d="M12 17v5M9 10.8a2 2 0 0 1-1.1 1.8l-1.8.9A2 2 0 0 0 5 15.2v.8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.8a2 2 0 0 0-1.1-1.7l-1.8-.9a2 2 0 0 1-1.1-1.8V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"
    />
  ),
  layers: (s?: number) => <I size={s ?? 20} d="m12 3 9 5-9 5-9-5 9-5zM3 13l9 5 9-5M3 17l9 5 9-5" />,
  /** directions: a folded map (the phone's maps app); `map` and `pin` are location markers */
  directions: (s?: number) => <I size={s ?? 20} d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2zM9 4v14M15 6v14" />,
  /** a word tag on a member (console, decision 181) */
  tag: (s?: number) => <I size={s ?? 20} d="M3 4v7l9 9 8-8-9-9H4a1 1 0 0 0-1 1zM7.5 7.5h.01" />,
  filter: (s?: number) => <I size={s ?? 20} d="M4 5h16l-6 8v6l-4-2v-4L4 5z" />,
  /** a list's order: arrows up and down */
  sort: (s?: number) => <I size={s ?? 16} d="M7 4v16M3 8l4-4 4 4M17 20V4M13 16l4 4 4-4" />,
  /** ghost mode: an eye, crossed through */
  ghost: (s?: number) => (
    <I
      size={s ?? 20}
      d="M3 3l18 18M10.6 5.1A9.8 9.8 0 0 1 12 5c5 0 8.5 4.2 9.6 6.4a1.3 1.3 0 0 1 0 1.2 15 15 0 0 1-2.8 3.6M6.6 6.6A15 15 0 0 0 2.4 11.4a1.3 1.3 0 0 0 0 1.2C3.5 14.8 7 19 12 19a9.7 9.7 0 0 0 5.4-1.6M9.9 9.9a3 3 0 0 0 4.2 4.2"
    />
  ),
  list: (s?: number) => <I size={s ?? 18} d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />,
  /** a drag handle: two columns of dots, to move a row in your own order */
  grip: (s?: number) => <I size={s ?? 18} d="M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01" />,
  /** the grid view: four tiles */
  grid: (s?: number) => <I size={s ?? 18} d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z" />,
  locate: (s?: number) => (
    <I
      size={s ?? 20}
      d="M12 2v3M12 19v3M2 12h3M19 12h3M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    />
  ),
}
